// extracted by css-extract-rspack-plugin
export default {"toastWrapper":"_d24db20d","toastHeader":"_54ccc81","toastHeaderText":"_5e2974bc","icon":"_68651f88"};